module.exports = __webpack_public_path__ + "static/media/maintenence-01.006c6383.png";